module.exports = __webpack_public_path__ + "static/media/icon-email.1e1abfe2.svg";